//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"KitName",1,0],[0,"OutputDirectory",1,0],[0,"PrintReport",1,0]],[[["fileCount"],"GetAllKitPaths",{R_:{kitFiles:""}},0,0],[["directory","file"],"AddKitFile",{},2,0],[["directory","folder"],"AddKitFolder",{},2,0],[["directory","subDirectory"],"AddKitDirectory",{},2,0],[["directory","newDirectoryName"],"RenameKitDirectory",{},2,0],[["directory"],"RemovePathInKit",{},1,0],[[],"LoadDeviceDirectory",{},0,0],[[],"LoadToolDirectory",{},0,0]],[]];
SPLM.SIM.ExportMachineKitBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.ExportMachineKitBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;